import { render, staticRenderFns } from "./MarketplacesCategoryTemplates.vue?vue&type=template&id=5fcfc7d2&scoped=true&"
import script from "./MarketplacesCategoryTemplates.vue?vue&type=script&lang=js&"
export * from "./MarketplacesCategoryTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MarketplacesCategoryTemplates.vue?vue&type=style&index=0&id=5fcfc7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcfc7d2",
  null
  
)

export default component.exports